var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "document-type-template" }, [
    _c("span", { class: ["e-fe-icon", _vm.iconClass] }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }